import React, { useState } from "react";
import styled from "styled-components";
import InputField from "./InputField.tsx";
import { HiOutlineMagnifyingGlass } from "react-icons/hi2";
import { useQuery } from "@tanstack/react-query";
import { getSearchProducts } from "../../../services/productsService.js";
import { useNavigate } from "react-router-dom";

const ProductsSuggestions = styled.div`
  position: absolute;
  z-index: 1;
  background-color: white;
  min-width: 200px;
  max-height: 300px;
  overflow-y: auto;
  margin-top: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  ul {
    padding: 0;
    margin: 0;
    list-style-type: none;
  }
`;

const Item = styled.li`
  padding: 8px;
  cursor: pointer;
  border-bottom: 1px solid #ddd;
`;

const Search: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const enabled = searchTerm !== "" && searchTerm.length > 2;

  const navigate = useNavigate();

  const { data: products } = useQuery(
    ["products", searchTerm],
    () => getSearchProducts(searchTerm),
    { enabled }
  );

  return (
    <div>
      <InputField
        name="search"
        placeholder="Search..."
        value={searchTerm}
        icon={<HiOutlineMagnifyingGlass />}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {products && products.length > 0 && (
        <ProductsSuggestions>
          <ul>
            {products.slice(0, 3).map((product) => (
              <Item
                key={product.productID}
                onClick={() => {
                  setSearchTerm("");
                  navigate(
                    `shop/${product.categoryName.toLowerCase()}/${
                      product.productID
                    }`
                  );
                }}
              >
                {product.productName}{" "}
              </Item>
            ))}
          </ul>
        </ProductsSuggestions>
      )}
    </div>
  );
};

export default Search;
